import axios from 'axios';
import { createAsyncThunk, createSlice, isFulfilled, isPending, isRejected } from '@reduxjs/toolkit';
import { API_ROUTES } from '@/config/api-routes';
import { serializeAxiosError, resolveAsyncThunkErrorMessage } from './reducer.utils';
const initialState = {
    loading: false,
    errorMessage: null,
    statistics: null,
};
export const getAgentStatistics = createAsyncThunk('agentStatistics/fetch', async ({ username, dateFrom, dateTo }) => {
    const params = new URLSearchParams();
    if (dateFrom)
        params.append('dateFrom', dateFrom);
    if (dateTo)
        params.append('dateTo', dateTo);
    const query = params.toString();
    const base = API_ROUTES.qstat.agentStatistics(username);
    const requestUrl = query ? `${base}?${query}` : base;
    return axios.get(requestUrl);
}, { serializeError: serializeAxiosError });
export const agentStatisticsSlice = createSlice({
    name: 'agentStatistics',
    initialState: initialState,
    reducers: {
        resetAgentStatistics() {
            return initialState;
        },
    },
    extraReducers(builder) {
        builder
            .addMatcher(isFulfilled(getAgentStatistics), (state, action) => {
            state.loading = false;
            state.statistics = action.payload.data;
        })
            .addMatcher(isPending(getAgentStatistics), (state) => {
            state.errorMessage = null;
            state.loading = true;
        })
            .addMatcher(isRejected(getAgentStatistics), (state, action) => {
            state.loading = false;
            state.statistics = null;
            state.errorMessage = resolveAsyncThunkErrorMessage(action.error);
        });
    },
});
export const { resetAgentStatistics } = agentStatisticsSlice.actions;
export default agentStatisticsSlice.reducer;
